import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@angular/material';
import { SlimScroll } from 'angular-io-slimscroll';
import {ToastModule} from 'ng2-toastr/ng2-toastr';
import { AddContactComponent } from './add-contact-modal/add-contact.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ConfirmModalComponent } from './confirm-modal/confirm-modal.component';
@NgModule({
  imports: [
    CommonModule,
    ToastModule.forRoot(),
    MaterialModule,
    ReactiveFormsModule
  ],
  declarations: [
    SlimScroll,
    AddContactComponent,
    ConfirmModalComponent
  ],
  exports: [
    SlimScroll,
    ToastModule,
    MaterialModule,
    AddContactComponent
  ],
  entryComponents: [
    AddContactComponent,
    ConfirmModalComponent
  ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// C:/www/onetouchSuperAdmin/src/app/shared/shared.module.ts